import AContainer from '../../library/ExtendedObjects/AContainer.js';
import WordBlock from './WordBlock.js';
import gameData from '../../gameData.js';

export default class PortalExport extends AContainer
{
    constructor(scene)
    {
        super(scene);

        this.name = "PortalExport";
    
        this.createPortal();
        this.createInitWords();
    }

    createPortal()
    {
        this.create(150, -260, "Chain");
        this.create(-150, -240, "Chain");
        this.portal = this.create(0, 0, "WordPortalBlue");

        this.verbsPast = gameData.pastVerbs.slice();
        this.verbsPresent = gameData.presentVerbs.slice();
        this.scene.shuffleArray(this.verbsPast);
        this.scene.shuffleArray(this.verbsPresent);
    }

    rotatePortal()
    {
        let randAngle = Phaser.Math.Between(0, 360);
        let randTime = Phaser.Math.Between(10000, 20000);

        this.scene.addTween(this.portal, randTime, {angle:randAngle}, Phaser.Math.Easing.Quadratic.InOut,
            ()=>{this.rotatePortal();});
    }

    tweenInPortal()
    {
        this.scene.playSound("question_machine");

        this.scene.addTween(this, 2000, {y:380}, Phaser.Math.Easing.Quadratic.Out,
            ()=>{this.activatePortals();});
    }

    tweenOutPortal()
    {
        this.scene.playSound("question_machine");
        
        this.scene.addTween(this, 1000, {y:-300}, Phaser.Math.Easing.Quadratic.In,
            ()=>{this.cleanUp();});
    }

    activatePortals()
    {
        for(let n = 0; n < this.words.length; n++){
            let newDelay = 100*n;
            this.words[n].tweenInBlock(newDelay);
        }

        this.scene.addDelay(1500, ()=>{
            if(!gameData.gamePaused) this.enableWords();
        });
    }

    createInitWords()
    {
        this.words = [];
        this.scene.shuffleArray(gameData.blockConfig);

        for(let n = 0; n < 6; n++){
            if(n % 2 === 0){
                gameData.blockConfig[n].type = "past";
                gameData.blockConfig[n].word = this.verbsPast[n/2];
            } else {
                gameData.blockConfig[n].type ="present";
                gameData.blockConfig[n].word = this.verbsPresent[Math.floor(n/2)];
            }


            let block = new WordBlock(this.scene, this, gameData.blockConfig[n]);
            block.x = 455 + gameData.blockConfig[n].x;
            block.y = 380 + gameData.blockConfig[n].y;
            this.scene.add.existing(block);
            block.setDepth(2);
            this.words.push(block);
        }

        //move the first 3 elements from word arrays to back.
        for(let n = 0; n < 3; n++){
            let pastS = this.verbsPast.splice(0, 1);
            this.verbsPast.push(pastS[0]);
            
            let presentS = this.verbsPresent.splice(0, 1);
            this.verbsPresent.push(presentS[0]);
        }

        //move the first 6 elements from configs arrays to back.
        for(let n = gameData.blockConfig.length-1; n >= 0; n--){
            let splice = gameData.blockConfig.splice(n, 1);
            gameData.blockConfig.push(splice[0]);
        }

        //normalize element indexes
        for(let b = 0; b < gameData.blockConfig.length; b++){
            gameData.blockConfig[b].ind = b;

            for(let w = 0; w >this.words.length; w++){
                this.words[w].config.ind = b;
            }
        }
    }

    clearWord(oldBlock)
    {
        oldBlock.resetWord("orange");

        for(let n = 0; n < this.words.length; n++){
            if(this.words[n].config.type === "present"){
                this.words[n].resetWord("blue");
                break;
            }
        }

        this.scene.addDelay(550, ()=>{this.createNewWords();});
    }

    clearPortal()
    {
        for(let n = 0; n < this.words.length; n++){
            this.words[n].clearWord();
        }
        
        this.scene.addDelay(1000, ()=>{this.scene.tweenOutPortals();});
    }

    createNewWords()
    {
        for(let n = 0; n < 2; n++){
            if(n % 2 === 0){
                gameData.blockConfig[n].type = "past";
                gameData.blockConfig[n].word = this.verbsPast[n/2];
            } else {
                gameData.blockConfig[n].type ="present";
                gameData.blockConfig[n].word = this.verbsPresent[Math.floor(n/2)];
            }

            let block = new WordBlock(this.scene, this, gameData.blockConfig[n]);
            block.x = this.x + gameData.blockConfig[n].x;
            block.y = 380 + gameData.blockConfig[n].y;
            this.scene.add.existing(block);
            block.setDepth(2);
            this.words.push(block);

            let newDelay = 100*n;
            block.tweenInBlock(newDelay);
        }

        //move the first element from word arrays to back.
        let pastS = this.verbsPast.splice(0, 1);
        this.verbsPast.push(pastS[0]);
        let presentS = this.verbsPresent.splice(0, 1);
        this.verbsPresent.push(presentS[0]);

        //move the first 2 elements from configs arrays to back.
        for(let n = 1; n >= 0; n--){
            let splice = gameData.blockConfig.splice(n, 1);
            gameData.blockConfig.push(splice[0]);
        }

        //normalize element indexes
        for(let b = 0; b < gameData.blockConfig.length; b++){
            gameData.blockConfig[b].ind = b;

            for(let w = 0; w >this.words.length; w++){
                this.words[w].config.ind = b;
            }
        }

        this.enableWords();
    }

    enableWords()
    {
        for(let n = 0; n < this.words.length; n++){
            this.words[n].setInteractive();
            this.scene.input.setDraggable(this.words[n]);
        }
    }

    disableWords()
    {
        for(let n = 0; n < this.words.length; n++){
            this.words[n].disableInteractive();
        }
    }

    cleanUp()
    {
        this.scene.killTween(this.portal);
        this.portal.destroy();

        this.disableWords();

        for(let n = 0; n < this.words.length; n++){
            this.words[n].cleanUp();
        }

        this.verbsPast = [];
        this.verbsPresent = [];
    }
}